module.exports = __webpack_public_path__ + "img/banner_desktop.c49cd463.png";